import React, { useEffect, useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { t } from "i18next";

const MobileWarningModal = () => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    window.localStorage.setItem(
      "mobileBannerDontShowAgain",
      dontShowAgain.toString()
    );
  }, [dontShowAgain]);
  return (
    <div className="p-4 flex flex-col gap-4">
      <p>{t("layout.mobile_message")}</p>
      <div className="flex gap-2 items-center">
        <Checkbox
          checked={dontShowAgain}
          onCheckedChange={(checked) => setDontShowAgain(Boolean(checked))}
          name="Don't show again"
        />
        <p>{t("layout.dont_show_again")}</p>
      </div>
    </div>
  );
};

export default MobileWarningModal;
